






import { defineComponent, CompType } from '../../vue';
import { ErrorObject } from 'ajv';
import { default as ValidationBadge } from './ValidationBadge.vue';
import { VIcon } from 'vuetify/lib';

export default defineComponent({
  name: 'validation-icon',
  components: {
    ValidationBadge,
    VIcon,
  },
  props: {
    errors: {
      required: true,
      type: Array as CompType<ErrorObject, ArrayConstructor>,
    },
  },
});
